.scrim {
  position: fixed;
  inset: 0;
  background: var(--c-scrim);
  z-index: 40;
}

.dialog {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 41;
  max-height: calc(100vh - 60px);
  display: flex;
  flex-direction: column;
  background: var(--c-surface-elevated);
  border: 1px solid var(--c-border-strong);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-modal);
  overflow: hidden;
  outline: none;
}

.sm {
  width: min(440px, calc(100vw - 40px));
}

.md {
  width: min(640px, calc(100vw - 40px));
}

.lg {
  width: min(920px, calc(100vw - 60px));
}

.xl {
  width: min(1240px, calc(100vw - 80px));
  height: min(780px, calc(100vh - 60px));
}

.header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 18px;
  border-bottom: 1px solid var(--c-border);
  flex: none;
}

.title {
  font-size: var(--text-subtitle);
  font-weight: 600;
}

.close {
  margin-left: auto;
}

.body {
  flex: 1;
  min-height: 0;
  overflow: auto;
  padding: 18px;
}

.flush {
  padding: 0;
  display: flex;
}

.footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  padding: 12px 18px;
  border-top: 1px solid var(--c-border);
  flex: none;
}

.confirmBody {
  font-size: var(--text-caption);
  color: var(--c-text-secondary);
  line-height: 1.55;
}

.textButton {
  height: 36px;
  padding: 0 14px;
  border: 0;
  border-radius: var(--radius-md);
  background: transparent;
  color: var(--c-text-secondary);
  font-weight: 600;
  font-size: var(--text-caption);
}

.textButton:hover {
  background: var(--c-overlay);
}

.confirm {
  height: 36px;
  padding: 0 16px;
  border: 0;
  border-radius: var(--radius-md);
  background: var(--c-brand);
  color: var(--c-on-brand);
  font-weight: 600;
  font-size: var(--text-caption);
}

.confirmDanger {
  background: var(--c-negative);
  color: #fff;
}

/* A held confirm (typed confirmation not yet entered, or busy) reads as not yet available: a pale
   wash of its colour, as on the phone, so the change to the solid colour signals it is armed. */
.confirm:disabled {
  background: var(--c-overlay);
  color: var(--c-text-tertiary);
  cursor: not-allowed;
}

.confirmDanger:disabled {
  background: var(--c-negative-subtle);
  color: color-mix(in srgb, var(--c-negative) 55%, transparent);
}
